import { useMediaQuery } from "@chakra-ui/react";
import { HEDERA } from "@constants/constants";

const token = process.env.NEXT_PUBLIC_TOKEN || "";

const useIsMobile = () => {
  const [isGreaterThan1280] = useMediaQuery("(min-width: 1280px)");
  return { isMobile: !isGreaterThan1280, isSupported: token !== HEDERA };
};

export default useIsMobile;
